export default __webpack_public_path__ + "static/01 - Foto alejandra-1d4d5b0e1011cac43bb82a59cff8b477.jpg";